<script setup lang="js">
import { ref, onMounted } from 'vue';
import { useRouteParams } from '@vueuse/router';
import { useAutonodeStore } from '@/stores/autonode.store';
import { useProjectStore } from '@/stores/project.store';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';
import { useNodeStore } from '@/stores/node.store';
import _ from 'lodash';

const autonodeStore = useAutonodeStore();
const projectStore = useProjectStore();
const nodeStore = useNodeStore();
const { return_values, selectedReturnIndex } = storeToRefs(autonodeStore);
const { project } = storeToRefs(projectStore);
const { bpNode } = storeToRefs(nodeStore);
const { closeModal } = useModal();
const projectId = useRouteParams('projectId');

const conditionValue = ref('');
const bp_node_return_id = ref(null);

function createAutnodeReturn() {
  if (selectedReturnIndex.value in return_values.value) {
    return_values.value = _.omit(return_values.value, selectedReturnIndex.value);
  }
  if (conditionValue.value) {
    return_values.value = {
      ...return_values.value,
      [conditionValue.value]: bp_node_return_id.value,
    };
  }

  closeModal();
}
onMounted(() => {
  if (!project.value.locales) {
    projectStore.getProject(projectId.value);
  }
  if (selectedReturnIndex.value in return_values.value) {
    conditionValue.value = selectedReturnIndex.value;
    bp_node_return_id.value = return_values.value[selectedReturnIndex.value];
  }
});
</script>

<template>
  <ModalTemplateSide @submit="createAutnodeReturn">
    <template v-slot:title>Добавить возврат</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Сравниваемое значение</label>
        <input type="text" class="form-control" v-model="conditionValue">
      </div>
      <div class="mt-3">
        <label class="form-label">Узел</label>
        <select v-model="bp_node_return_id" class="form-select">
          <option v-for="bpNodeReturn in bpNode.returns" :key="bpNodeReturn.returning_bp_node_id" :value="bpNodeReturn.id">
            {{ bpNodeReturn.return_bp_node.current.node.name }}
          </option>
        </select>
      </div>
    </template>
    <template v-slot:submit>Добавить</template>
  </ModalTemplateSide>
</template>
